import { Component, Input, OnInit, EventEmitter, Output, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { MedidoresService } from "../../servicios/medidores.service";
import { CatUbicacionMedidoresService } from "../../servicios/cat-ubicacion-medidores.service";
import { CatTipoMedidoresService } from "../../servicios/cat-tipo-medidores.service";
import { CatEstadoFuncionamientosService } from "../../servicios/cat-estado-funcionamientos.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { AguasService } from "../../servicios/aguas.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { Medidores, FlujoTramitesInput, MedidoresDTO, EstadoCuentaInformacionInput } from '../../entidades/entidades';
import { Aguas, RegistroBitacoraInput } from "../../entidades/entidades";
import { FlujoTramitesInputService } from '../../servicios/flujo-tramites.service';
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { CatUsuariosService } from '../../servicios/cat-usuarios.service';
import { Router } from '@angular/router';
import { EstadoCuentaInformacionComponent } from '../estado-cuenta-informacion/estado-cuenta-informacion.component';
import { AguaBuscaCuentasComponent } from '../agua-busca-cuentas/agua-busca-cuentas.component';
import { AltaMedidoresComponent } from '../alta-medidores/alta-medidores.component';

@Component({
  selector: "app-medidores-grid",
  templateUrl: "./medidores-grid.component.html",
  styleUrls: ["./medidores-grid.component.css"],
})
export class MedidoresGridComponent implements OnInit, OnChanges {
  muestraMensaje = new MuestraMensaje();
  catUbicacionMedidores: SelectItem[];
  catTipoMedidores: SelectItem[];
  catEstadoFuncionamientos: SelectItem[];
  catEstatus: SelectItem[];
  catUsuarios: SelectItem[];
  solicitudDetalles: SelectItem[];
  aguas: SelectItem[];
  public medidores: Medidores[]=[];
  public medidoresDTO: MedidoresDTO[]=[];

  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedMedidores: { [s: string]: Medidores } = {};
  public med : Medidores[]=[];
  guardaSerie: any;
  public registroBitacora = new RegistroBitacoraInput();
  agua: Aguas;
  @ViewChild(AltaMedidoresComponent) estadoCuentaInformacion: AltaMedidoresComponent;

  @Input("medidoresInput") medidoresInput: Medidores;
  @Input("IdSolicitud") IdSolicitud: number;
  @Input("usuario") usuario: number;
  @Input("esLecturaInput") esLecturaInput: boolean = false; 
  @Input("esMedidores") esMedidores: boolean = false; 


  @Output("medidoresOutput") medidoresOutput: EventEmitter<Medidores>;
  
  public _id_agua: number ;

  public progressBar = false;
  showBar() {
    this.progressBar = true;
  }

  constructor(
   private medidoresService: MedidoresService,
    private catUbicacionMedidoresService: CatUbicacionMedidoresService,
    private catTipoMedidoresService: CatTipoMedidoresService,
    private catEstadoFuncionamientosService: CatEstadoFuncionamientosService,
    private catEstatusService: CatEstatusService,
    private aguasService: AguasService,
    private flujoTramitesInputService: FlujoTramitesInputService,
    private registroBitacoraService: RegistroBitacoraService,
    private catUsuariosService: CatUsuariosService,
    private router: Router,
  ) {
    this.medidoresOutput = new EventEmitter();
  }


 
  ngOnInit(): void {
    this.getAllCatUbicacionMedidores();
    this.getAllCatTipoMedidores();
    this.getAllCatEstadoFuncionamientos();
    this.getAllCatEstatus();
    this.getAllCatUsuarios();
    
    // if(this.medidoresInput.idAgua)
    // {
    //   this.getAllMedidores();
    // }
    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Agregar",   icon: "pi pi-plus",  command: () => this.add(), },
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridMedidores();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllMedidores();} },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {
        field: "operacion",
        header: "",
        ordenar: false,
        styleHeader: "width: 80px;",
      },
      {
        field: "consecutivo",
        header: "Consecutivo",
        ordenar: false,
        styleHeader: "width: 150px;",
      },
      {
        field: "serie",
        header: "Serie",
        ordenar: false,
        styleHeader: "width: 130px;",
      },
      {
        field: "idEstatus",
        header: "Estatus",
        ordenar: false,
        styleHeader: "width: 180px;",
      },
      {
        field: "fechaInstalacion",
        header: "Fecha Instalación",
        ordenar: false,
        styleHeader: "width: 150px;",
      },
      {
        field: "fechaDesinstalacion",
        header: "Fecha Desinstalación",
        ordenar: false,
        styleHeader: "width: 150px;",
      },
      {
        field: "idUsuarioInstalo",
        header: "Usuario",
        ordenar: false,
        styleHeader: "width: 150px;",
      },
      {
        field: "lecturaFin",
        header: "Lectura Anterior",
        ordenar: false,
        styleHeader: "width: 150px;",
      },
      {
        field: "fechaIni",
        header: "Fecha Inicio",
        ordenar: false,
        styleHeader: "width: 140px;",
      },
      {
        field: "fechaFin",
        header: "Fecha Fin",
        ordenar: false,
        styleHeader: "width: 150px;",
      },
      {
        field: "observaciones",
        header: "Observaciones",
        ordenar: false,
        styleHeader: "width: 150px;",
      },
      
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.medidoresInput.idAgua)
    {
      this.getAllMedidores();
    }
  }
   
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    
    // Actualiza el medidor anterior 
    if (this.medidores.length > 0) { 
      this.medidores.forEach(element => {
        if(element.idEstatus == 1)
        {
          element.idEstatus = 4;
          element.fechaFin = new Date();
          element.cambio = true;
        }
      }); 
     /* let lastIndex = this.medidores.find(x => x.idEstatus == 1)?.id; // Índice del último medidor
      this.medidores[lastIndex].idEstatus = 4;
      this.medidores[lastIndex].fechaFin = new Date();
      this.medidores[lastIndex].cambio = true;*/
  }
    
 /*   if(this.medidores.length==2)
      throw new Error('No puedes agregar mas de un medidor.');
*/
    let medidoresNew = new Medidores();
    medidoresNew.cambio = true;
    medidoresNew.serie =' ';
    medidoresNew.idEstatus = 1;
    medidoresNew.id = 0;
    medidoresNew.fechaIni = new Date(new Date());
    medidoresNew.lecturaAnt = 0;
    medidoresNew.consecutivo = this.agua?.consecutivo;
    this.medidores.push(medidoresNew);
    this.medidoresDTO.push(medidoresNew);
    this.clonedMedidores[0]= {...medidoresNew};

    // this.medidores.unshift(medidoresNew);
  }

  

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let medidoresEdit = event.data;
    medidoresEdit.cambio = true;
    medidoresEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let medidoresEdit = event.data;
    let index = this.medidores.findIndex(
      (obj) => obj.id === medidoresEdit.id
    );
    this.medidores[index] = { ...this.clonedMedidores[medidoresEdit.id]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let medidoresEdit = event.data;
      
      const registrosActivos = this.medidores.filter(x => x.idEstatus == 1);
      //Valida si hay cambios
      if (
        medidoresEdit.id === this.clonedMedidores[medidoresEdit.id].id &&
        medidoresEdit.serie === this.clonedMedidores[medidoresEdit.id].serie &&
        medidoresEdit.idUbicacionMedidor === this.clonedMedidores[medidoresEdit.id].idUbicacionMedidor &&
        medidoresEdit.idTipoMedidor === this.clonedMedidores[medidoresEdit.id].idTipoMedidor &&
        medidoresEdit.idEstadoFuncionamiento === this.clonedMedidores[medidoresEdit.id].idEstadoFuncionamiento &&
        medidoresEdit.idEstatus === this.clonedMedidores[medidoresEdit.id].idEstatus &&
        medidoresEdit.fechaIni === this.clonedMedidores[medidoresEdit.id].fechaIni &&
        medidoresEdit.fechaFin === this.clonedMedidores[medidoresEdit.id].fechaFin &&
        medidoresEdit.idUsuarioInstalo === this.clonedMedidores[medidoresEdit.id].idUsuarioInstalo &&
        medidoresEdit.idSolicitudDetalle === this.clonedMedidores[medidoresEdit.id].idSolicitudDetalle &&
        medidoresEdit.idAgua === this.clonedMedidores[medidoresEdit.id].idAgua  &&
        medidoresEdit.consecutivo === this.clonedMedidores[medidoresEdit.id].consecutivo &&
        medidoresEdit.observaciones === this.clonedMedidores[medidoresEdit.id].observaciones &&
        medidoresEdit.fechaInstalacion === this.clonedMedidores[medidoresEdit.id].fechaInstalacion &&
        medidoresEdit.fechaDesinstalacion === this.clonedMedidores[medidoresEdit.id].fechaDesinstalacion &&
        medidoresEdit.lecturaAnt === this.clonedMedidores[medidoresEdit.id].lecturaAnt && 
        registrosActivos.length < 2
      ) {
        let index = this.medidores.findIndex((obj) => obj.id === medidoresEdit.id);
        this.medidores[index] = {...this.clonedMedidores[medidoresEdit.id]};
        return;
      }

      if (registrosActivos.length >= 2) {
        throw new Error("Hay mas de dos medidores vigentes.");
      }
      //Validaciones
      //throw new Error("No paso las validaciones.");
      medidoresEdit.cambio = true;
      medidoresEdit.baja = false;

 
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridMedidores() 
  {
    try 
    
    {
      this.showBar(); 

      const registrosActivos = this.medidores.filter(x => x.idEstatus == 1);
      if (registrosActivos.length >= 2) {
        throw new Error("Hay mas de dos medidores vigentes. Primeramente cancele uno.");
      }

      if (this.medidores.length === 1 && this.medidores[0].serie === ' ')
        throw new Error('Ingrese una Serie valida.');
      this.guardaSerie = this.medidoresInput;
      for (let medidoresFor of this.medidores) {
        medidoresFor.idAgua = this._id_agua;   
        medidoresFor.fechaIni = medidoresFor.fechaInstalacion;
        if (medidoresFor.baja) {
          await this.deleteMedidores(medidoresFor);
        } else if (medidoresFor.cambio) {
          medidoresFor.cambio = false;
          this.clonedMedidores[medidoresFor.id] = { ...medidoresFor, };
          if (medidoresFor.id === 0) {
            const datoRetorno = await this.addMedidores(medidoresFor);
            medidoresFor.id = datoRetorno.id;
            await this.medidoresOutput.emit(datoRetorno);
          } else {
            await this.updateMedidores(medidoresFor);
            
          }
        }
      }     
      let flujoSolicitudes = new FlujoTramitesInput;
      flujoSolicitudes.idSolicitudDetalle = this.IdSolicitud;
      flujoSolicitudes.idUsuario = this.usuario;
      flujoSolicitudes.inicio = false;  
      flujoSolicitudes.idEstatus = 5;
      
      await this.flujoTramitesInputService.add(flujoSolicitudes).toPromise();
      //await this.getAllMedidores();

      let aguas = new Aguas;
      aguas.id = this._id_agua;
      aguas.idTipoServicio = 3; // Servicio Medido 
      await this.aguasService.actualiza(aguas).toPromise();
      this.registroBitacora.idAgua = this.medidoresInput.idAgua;
      this.registroBitacora.idMovAsegurar = 1;
      this.registroBitacora.accion = "SE DIÓ DE ALTA MEDIDOR/CAMBIO EL MEDIDOR DE LA CUENTA: " + this.agua.cuentaAgua;
      await this.registroBitacoraService.add(this.registroBitacora).toPromise();
       
      this.getAllMedidores();
      this.muestraMensaje.notification(
        "Guardar con éxito",
        "top",
        "center"
      ); 
      //================================================================================================================================
      //  SE ACTUALIZA REGISTROS DE CONSUMOS ANTERIORES (SE CAMBIA EL TIPO SERVICIO)
      //================================================================================================================================
      //Se comenta porque no se encuentra la funcion
      //await this.medidoresService.updateConsumo(this._id_agua).toPromise();


      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarMedidores");
      this.progressBar = false;
    }
  }
  async limpiar() {
    this.medidoresDTO = null;
  }

  async getMedidores(id: number) {
    try {
      const datoRetorno = await this.medidoresService
        .getSingle(id)
        .toPromise();
      // this.medidoresForm.patchValue(datoRetorno);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getMedidores");
    }
  }

  // prettier-ignore
  async addMedidores(medidores) {
    try {
      this.agua.consecutivo = medidores.consecutivo;
      this.agua.idEstatus = 19 ; 
      const datoAguas = await this.aguasService
      .update(this.agua)
      .toPromise();
      const datoretorno = await this.medidoresService
        .add(medidores)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addMedidores");
    }
  }

  // prettier-ignore
  async getAllMedidores() {
    try {
      
      this.medidores.splice(0);
      this.medidoresDTO.splice(0);
      let medidoresB = new Medidores();
      medidoresB.idAgua = this.medidoresInput.idAgua;
      const no = Object.keys(this.medidoresInput);
      for (var i = 0, len = no.length; i < len; ++i) {
        medidoresB.idAgua= this.medidoresInput.idAgua;
        this._id_agua = this.medidoresInput.idAgua;
         
      }

      if(this.medidoresInput.idAgua == null)
        throw new Error('No se envia cuenta.');
       const datoRetorno = await this.medidoresService.getBusquedas(this.medidoresInput).toPromise();
       
      const numero = Object.keys(datoRetorno);

      const datoAgua = await this.aguasService.getSingle(this.medidoresInput.idAgua).toPromise();
      this.agua = datoAgua;


      for (var i = 0, len = numero.length; i < len; ++i) {
          datoRetorno[i].fechaIni = new Date(datoRetorno[i].fechaIni);
          datoRetorno[i].fechaFin = new Date(datoRetorno[i].fechaFin);
          datoRetorno[i].consecutivo =  this.agua?.consecutivo;
        this.medidores.push( datoRetorno[i]);
        this.medidoresDTO.push( datoRetorno[i]);
      }
      for (var i = 0, len = this.medidores.length; i < len; ++i)
         this.clonedMedidores[this.medidores[i].id] = {...this.medidores[i],        };
 


    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllMedidores");
    }
  }

    // prettier-ignore
    async getAllMedidoresRecargar() {
      try {
        const datoRetorno = await this.medidoresService.getAll().toPromise();
        for (var i = 0, len = datoRetorno.length; i < len; ++i){
          if (datoRetorno[i].fechaIni instanceof Date) {
            datoRetorno[i].fechaIni = new Date(datoRetorno[i].fechaIni);
          }
          if (datoRetorno[i].fechaFin instanceof Date) {
            datoRetorno[i].fechaFin = new Date(datoRetorno[i].fechaFin);
          }
        }
        this.medidores = datoRetorno;
        for (var i = 0, len = this.medidores.length; i < len; ++i)
          this.clonedMedidores[this.medidores[i].id] = {...this.medidores[i],};
      } catch (e) {
        if (e.response) throw { message: e.response.data };
        else throw e;
      } finally {
        console.log("Paso por getAllMedidores");
      }
    }



  // prettier-ignore
  async updateMedidores(medidores: Medidores) {
    try {
      this.agua.consecutivo = medidores.consecutivo;
      const datoAguas = await this.aguasService
      .update(this.agua)
      .toPromise();
      const datoRetorno = await this.medidoresService
        .update(medidores)
        .toPromise();
        await this.medidoresOutput.emit(medidores);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateMedidores");
    }
  }

  // prettier-ignore
  async deleteMedidores(medidores: Medidores) {
    try {
      const datoRetorno = await this.medidoresService
        .delete(medidores.id)
        .toPromise();
      this.medidoresOutput.emit(medidores);
      this.getAllMedidores();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteMedidores");
    }
  }

  // prettier-ignore
  async getAllCatUbicacionMedidores() {
    try {
      const datoRetorno = await this.catUbicacionMedidoresService.getAll().toPromise();
      this.catUbicacionMedidores = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catUbicacionMedidores.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUbicacionMedidores");
    }
  }

  // prettier-ignore
  async getAllCatTipoMedidores() {
    try {
      const datoRetorno = await this.catTipoMedidoresService.getAll().toPromise();
      this.catTipoMedidores = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoMedidores.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoMedidores");
    }
  }

  // prettier-ignore
  async getAllCatEstadoFuncionamientos() {
    try {
      const datoRetorno = await this.catEstadoFuncionamientosService.getAll().toPromise();
      this.catEstadoFuncionamientos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catEstadoFuncionamientos.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstadoFuncionamientos");
    }
  }

  // prettier-ignore
  async getAllCatEstatus() {
    try {
      const datoRetorno = await this.catEstatusService.getEstatusMedidor().toPromise();
      this.catEstatus = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catEstatus.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstatus");
    }
  }



  // // prettier-ignore
  async getAllAguas() {
    try {
      const datoRetorno = await this.aguasService.getAll().toPromise();
      this.aguas = datoRetorno.map((datos) => {
        return { label: datos.cuentaAguaAnterior, value: datos.id };
      });
      this.aguas.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAguas");
    }
  }
  async getAllCatUsuarios() {
    try {
      const datoRetorno = await this.catUsuariosService.getAll().toPromise();
      this.catUsuarios = datoRetorno.map((datos)=>{return { label: datos.nombre + ' ' + datos.primerApellido, value: datos.id, cuadrilla: datos.cuadrilla }});
      this.catUsuarios.unshift({ label: 'SELECCIONA...', value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatUsuarios");
    }
  };

  
}